import { Controller } from "@hotwired/stimulus"

// Debounced employee search for the deal-team picker. Picking a user fills the
// hidden user_id field and enables the submit button.
export default class extends Controller {
  static targets = ["query", "results", "userId", "submitBtn", "addPanel"]
  static values  = { searchUrl: String, debounceMs: { type: Number, default: 250 } }

  disconnect() { if (this.timer) clearTimeout(this.timer) }

  // Reveal/hide the inline "add team member" panel; the team list itself is
  // always visible, so this only toggles the search/add controls.
  toggleAdd() {
    if (!this.hasAddPanelTarget) return
    this.addPanelTarget.classList.toggle("d-none")
    if (!this.addPanelTarget.classList.contains("d-none") && this.hasQueryTarget) {
      this.queryTarget.focus()
    }
  }

  scheduleSearch() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.search(), this.debounceMsValue)
  }

  async search() {
    const q = this.queryTarget.value.trim()
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(q)}`
    try {
      const res = await fetch(url, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const { users } = await res.json()
      this.render(users || [])
    } catch (_) { /* swallow */ }
  }

  render(users) {
    if (!users.length) {
      this.resultsTarget.innerHTML = `<div class="list-group-item small text-muted">No matches</div>`
      return
    }
    this.resultsTarget.innerHTML = users.map(u => `
      <button type="button" class="list-group-item list-group-item-action"
              data-action="click->sales-deal-team-picker#select"
              data-user-id="${u.id}"
              data-user-name="${this.esc(u.name || u.email)}">
        <div class="fw-semibold">${this.esc(u.name || '(no name)')}</div>
        <div class="text-muted small">${this.esc(u.email)}</div>
      </button>
    `).join("")
  }

  select(event) {
    const btn = event.currentTarget
    this.userIdTarget.value = btn.dataset.userId
    this.queryTarget.value  = btn.dataset.userName
    this.resultsTarget.innerHTML = ""
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = false
  }

  esc(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    }[c]))
  }
}
